import DeptPage from "@/pages/zones/DeptPage";
import { departmentsData } from "@/mocks/departments";

export default function Yvelines78Page() {
  return <DeptPage dept={departmentsData["yvelines-78"]} />;
}
